//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loadAmap from '@/utils/amap'

export default {
  name: 'maps',
  data () {
    return {
      map: null,
      marker: null,
      placeSearch: null,
      geocoder: null,
      keyword: '',
      searchResults: [],
      selectedAddress: '',
      selectedLocation: null,
      selectionSequence: 0,
      lastSelectionKey: '',
      lastSelectionAt: 0
    }
  },
  mounted () {
    this.$func.setSession('address', '')
    loadAmap().then(() => {
      this.initMap()
    }).catch(() => {
      this.$func.showToast('地图加载失败，请稍后重试')
    })
  },
  beforeDestroy () {
    this.selectionSequence += 1
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    initMap () {
      const lng = Number(this.$route.params.longitude)
      const lat = Number(this.$route.params.latitude)
      const hasLocation = !isNaN(lng) && !isNaN(lat) && lng !== 0 && lat !== 0
      const center = hasLocation ? [lng, lat] : [108.947740, 34.259968]
      this.map = new AMap.Map('location-picker-map', {
        center: center,
        zoom: 16,
        resizeEnable: true
      })
      this.map.addControl(new AMap.Scale())
      this.placeSearch = new AMap.PlaceSearch({
        city: '西安市',
        citylimit: false,
        pageSize: 20,
        pageIndex: 1,
        extensions: 'base'
      })
      this.geocoder = new AMap.Geocoder()
      this.map.on('click', event => {
        this.searchResults = []
        this.selectCoordinate(event.lnglat)
      })
      const address = this.$route.query && String(this.$route.query.address || '').trim()
      if (address && address !== '请在地图上标注社区所在位置') {
        this.searchInitialAddress(address, hasLocation ? new AMap.LngLat(lng, lat) : null)
      } else if (hasLocation) {
        this.selectCoordinate(new AMap.LngLat(lng, lat), false)
      }
    },
    searchInitialAddress (address, fallbackLocation) {
      this.placeSearch.search(address, (status, result) => {
        const pois = status === 'complete' && result.poiList ? result.poiList.pois : []
        if (pois && pois.length) {
          this.selectPoi(pois[0], false)
        } else if (fallbackLocation) {
          this.selectCoordinate(fallbackLocation, false)
        }
      })
    },
    searchLocation () {
      if (!this.keyword) {
        this.$func.showToast('请输入地点名称')
        return
      }
      this.placeSearch.search(this.keyword, (status, result) => {
        const pois = status === 'complete' && result.poiList ? result.poiList.pois : []
        this.searchResults = pois || []
        if (!this.searchResults.length) {
          this.$func.showToast('未找到匹配的位置')
          return
        }
      })
    },
    selectPoi (poi, closeResults = true) {
      if (!poi || !poi.location) return
      const location = poi.location
      const selectionKey = poi.id || `${location.getLng()},${location.getLat()}`
      const now = Date.now()
      if (selectionKey === this.lastSelectionKey && now - this.lastSelectionAt < 400) return
      this.lastSelectionKey = selectionKey
      this.lastSelectionAt = now
      this.map.setZoomAndCenter(17, location)
      this.setMarker(location)
      const address = this.poiAddress(poi) || poi.name || ''
      this.resolveSelection(location, this.poiAddress(poi) || poi.name, poi.name || '')
      this.saveSelection(location, address, poi.name || '')
      if (closeResults) {
        this.searchResults = []
      }
    },
    selectCoordinate (location, moveMap = true) {
      if (!location) return
      if (moveMap) {
        this.map.setCenter(location)
      }
      this.setMarker(location)
      this.resolveSelection(location, `${location.getLng().toFixed(6)},${location.getLat().toFixed(6)}`, '')
      this.saveSelection(location, `${location.getLng().toFixed(6)},${location.getLat().toFixed(6)}`, '')
    },
    setMarker (location) {
      if (!this.marker) {
        this.marker = new AMap.Marker({map: this.map, anchor: 'bottom-center'})
        this.marker.on('click', event => {
          this.selectCoordinate(event.lnglat, false)
        })
      }
      this.marker.setPosition(location)
    },
    resolveSelection (location, fallbackAddress, name) {
      const sequence = ++this.selectionSequence
      this.selectedLocation = null
      this.selectedAddress = '正在获取详细地址...'
      this.$func.setSession('address', '')
      this.geocoder.getAddress(location, (status, result) => {
        if (sequence !== this.selectionSequence) return
        const address = status === 'complete' && result.regeocode
          ? result.regeocode.formattedAddress
          : fallbackAddress
        this.saveSelection(location, address, name)
      })
    },
    saveSelection (location, address, name) {
      const payload = {
        module: 'locationPicker',
        latlng: {lat: location.getLat(), lng: location.getLng()},
        poiaddress: address || '',
        poiname: name || ''
      }
      this.selectedLocation = payload.latlng
      this.selectedAddress = payload.poiaddress
      this.$func.setSession('address', JSON.stringify(payload))
    },
    poiAddress (poi) {
      if (!poi) return ''
      const parts = [poi.pname, poi.cityname, poi.adname, Array.isArray(poi.address) ? poi.address.join('') : poi.address]
      return parts.filter((part, index) => part && parts.indexOf(part) === index).join('')
    },
    confirm () {
      if (!this.selectedLocation) {
        this.$func.showToast('请选择位置信息')
        return
      }
      this.$router.back(-1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/maps.vue